<template>
  <div id="webId">
    <div>你的web页面</div>
    <div class="xuanfu" id="moveDiv"
         @mousedown="down" @touchstart="down"
         @mousemove="move" @touchmove.prevent="move"
         @mouseup="end" @touchend="end">
      <div class="yuanqiu"></div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  export default{
    data(){
      return {
        flags: false,
        position: {x: 0, y: 0},
        nx: '', ny: '', dx: '', dy: '', xPum: '', yPum: '',
      }
    },

    computed: {},

    created(){
    },

    methods: {
      down(){
        this.flags = true;
        var touch;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        this.position.x = touch.clientX;
        this.position.y = touch.clientY;
        this.dx = moveDiv.offsetLeft;
        this.dy = moveDiv.offsetTop;
      },
      move(){
        if (this.flags) {
          var touch;
          if (event.touches) {
            touch = event.touches[0];
          } else {
            touch = event;
          }
          this.nx = touch.clientX - this.position.x;
          this.ny = touch.clientY - this.position.y;
          this.xPum = this.dx + this.nx;
          this.yPum = this.dy + this.ny;
          moveDiv.style.left = this.xPum + "px";
          moveDiv.style.top = this.yPum + "px";
          //阻止页面的滑动默认事件；如果碰到滑动问题，1.2 请注意是否获取到 touchmove
          document.addEventListener("touchmove", function () {
            event.preventDefault();
          }, false);
        }
      },
      end(){
        this.flags = false;
      },
    },

    components: {}
  }
</script>

<style lang="less" rel="stylesheet/less" scoped="true">
  .xuanfu {
    height: 100px;
    width: 100px;
    /* 如果碰到滑动问题，1.3 请检查 z-index。z-index需比web大一级*/
    z-index: 999;
    position: fixed;
    top: 100px;
    right: 100px;
    border-radius: 30px;
    background-color: rgba(0, 0, 0, 0.55);
  }

  .yuanqiu {
    height: 50px;
    width: 50px;
    border: 1px solid rgba(140, 136, 136, 0.5);
    margin: 20px auto;
    color: #000000;
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    border-radius: 100%;
    background-color: #ffffff;
  }
</style>
